module.exports = __webpack_public_path__ + "img/carrousel-pacs-4.9735f0c1.png";